import clsx from 'clsx';

const TABS = [
  { key: 'rules', label: 'قواعد التسعير' },
  { key: 'packages', label: 'الباقات' },
  { key: 'discounts', label: 'الخصومات' },
  { key: 'subscriptions', label: 'الاشتراكات الشهرية' },
  { key: 'simulator', label: 'محاكي الأسعار' }
];

export function PricingTabs({ value, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 p-1 bg-white border border-line rounded-[10px] shadow-card">
      {TABS.map((t) => (
        <button
          key={t.key}
          type="button"
          onClick={() => onChange(t.key)}
          className={clsx(
            'px-3.5 py-1.5 rounded-[8px] text-[12.5px] font-semibold transition-colors',
            value === t.key
              ? 'bg-orange text-white shadow-orange-glow'
              : 'text-ink-2 hover:bg-paper-2'
          )}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
